"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSTRUCTORS = {
  Object: Object,
  Array: Array,
  Function: Function,
  Number: Number,
  String: String,
  Date: Date,
  RegExp: RegExp
};
/* istanbul ignore else */

if (typeof Buffer != "undefined") CONSTRUCTORS.Buffer = Buffer;
/* istanbul ignore else */

if (typeof Promise != "undefined") CONSTRUCTORS.Promise = Promise;
var getDef = Object.assign(_getDef, {
  CONSTRUCTORS: CONSTRUCTORS
});

function _getDef() {
  return {
    keyword: "instanceof",
    schemaType: ["string", "array"],
    compile: function compile(schema) {
      if (typeof schema == "string") {
        var C = getConstructor(schema);
        return function (data) {
          return data instanceof C;
        };
      }

      if (Array.isArray(schema)) {
        var constructors = schema.map(getConstructor);
        return function (data) {
          var _iterator = _createForOfIteratorHelper(constructors),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _C = _step.value;
              if (data instanceof _C) return true;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return false;
        };
      }
      /* istanbul ignore next */


      throw new Error("ajv implementation error");
    },
    metaSchema: {
      anyOf: [{
        type: "string"
      }, {
        type: "array",
        items: {
          type: "string"
        }
      }]
    }
  };
}

function getConstructor(c) {
  var C = CONSTRUCTORS[c];
  if (C) return C;
  throw new Error("invalid \"instanceof\" keyword value ".concat(c));
}

exports.default = getDef;
module.exports = getDef;